let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hsi4A")).then(() => parcelRequire('8WKUg'));